// IocRow.jsx 🧠🔍 Enhanced with Tag Match Detection & Delete Support
import React from "react";
import IocRowDetails from "./IocRowDetails";

const statusColors = {
  closed: "#b3947a",
  ongoing: "#a8a8f0",
  rejected: "#b3947a",
  acknowledged: "#b3947a",
  pending: "#f0a8a8",
};

const stripHtmlAndDecode = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};

// 🔍 Fonction utilitaire : détection de correspondance avec tags utilisateur
const getMatchedTags = (ioc, personalTags) => {
  const description = ioc.description?.toLowerCase() || "";
  const value = ioc.ioc_value?.toLowerCase() || "";
  const tags = (ioc.tags || "").toLowerCase();

  return personalTags.filter(tag =>
    description.includes(tag.toLowerCase()) ||
    value.includes(tag.toLowerCase()) ||
    tags.includes(tag.toLowerCase())
  );
};

const IocRow = ({
  ioc,
  isExpanded,
  toggleCollapse,
  onDelete,
  onEditSuccess,
  userCountryCode,
  personalTags = [] // 🧠 Injecté ici depuis le parent
}) => {
  const createdDate = new Date(ioc.created_at);
  const created = createdDate.toLocaleString();
  const isToday = createdDate.toDateString() === new Date().toDateString();


  return (
    <>
      {/* 🔹 LIGNE PRINCIPALE */}
      <tr
        key={`row-${ioc.id}`}
        style={{ cursor: "pointer" }}
        onClick={() => toggleCollapse(ioc.id)}
      >
        <td className="text-center" style={{
          backgroundColor: "#282727",
          maxWidth: "55px",
          minWidth: "55px",
          padding: "10px"
        }}>
          <img
            src={`img/${ioc.ioc_type.toLowerCase()}.svg`}
            alt={ioc.ioc_type}
            style={{
              width: "25px",
              height: "25px"
            }}
          />
        </td>

        <td
		  style={{
			backgroundColor: "#282727",
			padding: "10px",
			color: "#c77a3a",
			fontWeight: "bold",
			maxWidth: "300px",
			minWidth: "300px",
			whiteSpace: "nowrap",
			overflow: "hidden",
			textOverflow: "ellipsis"
		  }}
		>
		  {!!ioc.related_to_incident && (
			<i
			  className="bi bi-exclamation-triangle-fill"
			  style={{
				color: "#f0a85c",
				marginRight: "6px",
				fontSize: "1rem",
				verticalAlign: "middle"
			  }}
			></i>
		  )}
		  {ioc.ioc_value}
		</td>

        <td
          style={{
            backgroundColor: "#282727",
            padding: "10px",
            maxWidth: "700px",
            minWidth: "700px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}
        >
          {/* ✅ Affichage icône si tag matché */}
          {getMatchedTags(ioc, personalTags).length > 0 && (
			  <i
				className="bi bi-tags-fill"
				style={{ color: "#b3947a", marginRight: "5px", cursor: "pointer" }}
				data-bs-toggle="tooltip"
				data-bs-placement="top"
				title={`Tags detected : ${getMatchedTags(ioc, personalTags).join(", ")}`}
			  ></i>
			)}
          {ioc.description ? stripHtmlAndDecode(ioc.description) : "—"}
        </td>

        <td className="text-center" style={{
          backgroundColor: "#282727",
          maxWidth: "90px",
          minWidth: "90px",
          padding: "10px"
        }}>
          <span
            className="badge"
            style={{
              backgroundColor: statusColors[ioc.status] || "#b3947a",
              color: "#1e1e1e",
              borderRadius: "4px",
              fontWeight: "bold",
              padding: "6px 12px",
            }}
          >
            {ioc.status}
          </span>
        </td>

        <td
          className="text-center"
          style={{
            backgroundColor: isToday ? "#323232" : "#282727",
			color: isToday ? "#f8f9fa" : undefined,
            padding: "10px",
            whiteSpace: "nowrap",
            maxWidth: "180px",
            minWidth: "180px",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {created}
        </td>
      </tr>

      {/* 🔻 COLLAPSIBLE DETAILS */}
      <IocRowDetails
        key={`details-${ioc.id}`}
        ioc={ioc}
        isExpanded={isExpanded}
        onDelete={onDelete}
        onEditSuccess={onEditSuccess}
        userCountryCode={userCountryCode}
      />
    </>
  );
};

export default IocRow;
